// src/store/modules/allListings.module.js
import ListingService from "@/services/listing.service";

const state = () => ({
  list: [],
  total: 0,
  loading: false,
  error: null,

  // NEW: keep the last request params to reuse on refreshes
  lastParams: {
    page: 1,
    perPage: 10,
    sortBy: "id",
    sortDesc: false,
    search: "",
    status: "",
    category_id: "",
    only_reported: false,
  },
});

const mutations = {
  SET_LOADING(state, val) {
    state.loading = val;
  },
  SET_ALL_LISTINGS(state, { data, total }) {
    state.list = data;
    state.total = Number.isFinite(total) ? total : 0;
  },
  SET_ERROR(state, err) {
    state.error = err;
  },
  // NEW
  SET_LAST_PARAMS(state, params) {
    state.lastParams = { ...state.lastParams, ...params };
  },
};

const actions = {
  // async fetchAllListings({ commit, state }, params = {}) {
  //   commit("SET_LOADING", true);
  //   commit("SET_ERROR", null);

  //   // merge with last params so we always have a complete set
  //   const merged = { ...state.lastParams, ...params };
  //   commit("SET_LAST_PARAMS", merged);

  //   try {
  //     const res = await ListingService.index(merged);

  //     console.log("Fetched listings:", res.data);
  //     // Laravel paginator shape: { data: [], meta: { total, per_page, current_page, ... } }
  //     const rows = res?.data?.data ?? [];
  //     const total = Number(res?.data?.meta?.total ?? 0);

  //     commit("SET_ALL_LISTINGS", { data: rows, total });
  //   } catch (err) {
  //     commit("SET_ERROR", err?.response?.data?.message || err.message || err);
  //     commit("SET_ALL_LISTINGS", { data: [], total: 0 });
  //   } finally {
  //     commit("SET_LOADING", false);
  //   }
  // },

  // If you update inline somewhere else, call refreshSameView() after success

  async fetchAllListings({ commit, state }, params = {}) {
    commit("SET_LOADING", true);
    commit("SET_ERROR", null);

    // merge with last params so we always have a complete set
    const merged = { ...state.lastParams, ...params };
    commit("SET_LAST_PARAMS", merged);

    try {
      const res = await ListingService.index(merged);

      console.log("Fetched listings:", res.data);

      // Check if we're getting all listings (non-paginated response)
      if (merged.all === true || merged.perPage === "all") {
        // Non-paginated response - data is directly in res.data
        const rows = Array.isArray(res?.data?.data) ? res.data.data : [];
        const total = rows.length; // Total is just the length of returned data

        commit("SET_ALL_LISTINGS", { data: rows, total });
      } else {
        // Paginated response - Laravel paginator shape: { data: [], meta: { total, per_page, current_page, ... } }
        const rows = res?.data?.data ?? [];
        const total = Number(res?.data?.meta?.total ?? 0);

        commit("SET_ALL_LISTINGS", { data: rows, total });
      }
    } catch (err) {
      commit("SET_ERROR", err?.response?.data?.message || err.message || err);
      commit("SET_ALL_LISTINGS", { data: [], total: 0 });
    } finally {
      commit("SET_LOADING", false);
    }
  },

  async refreshSameView({ dispatch, state }) {
    await dispatch("fetchAllListings", state.lastParams);
  },

  async fetchListingById({ commit }, listingId) {
    commit("SET_LOADING", true);
    commit("SET_ERROR", null);
    try {
      const res = await ListingService.show(listingId);
      return res.data.data;
    } catch (err) {
      commit("SET_ERROR", err);
      throw err;
    } finally {
      commit("SET_LOADING", false);
    }
  },

  async deleteListing({ dispatch, state }, listing) {
    await ListingService.delete(listing);
    // Re-fetch with same params/page/sort/search/status/category
    await dispatch("fetchAllListings", state.lastParams);
  },
};

const getters = {
  allListings: (state) => state.list,
  listingsTotal: (state) => state.total,
  isLoading: (state) => state.loading,
  fetchError: (state) => state.error,
  getListingById: (state) => (id) => state.list.find((l) => l.id === id),
  // NEW: handy if you need to read current server params in the component
  currentParams: (state) => state.lastParams,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
